import { i18nInit } from '@pletly/common';

import { i18n as i18nUiLib } from '@pletly/ui';
import { i18n as i18nAuthLib } from '@pletly/feature-auth';
import { i18n as i18nAboutLib } from '@pletly/feature-about';
import { i18n as i18nOrganisationsLib } from '@pletly/feature-organisation';
import { i18n as i18nAutoBlurLib } from '@pletly/feature-auto-blur';

import { setLocale } from '%helpers/date';
import { resources } from './locales/index';

// eslint-disable-next-line i18next/no-literal-string
export const defaultNS = 'pletly-pal';

const otherInstances = [
	i18nUiLib,
	i18nAuthLib,
	i18nAboutLib,
	i18nOrganisationsLib,
	i18nAutoBlurLib,

	{
		changeLanguage: setLocale,
	},
];
const i18n = i18nInit({ resources, defaultNS }, otherInstances);

export { resources } from './locales/index';

export default i18n;
